import React from "react";
import PublicAuths from "./PublicAuth";
import Login from "../Views/Auth/Login";
import Register from "../Views/Auth/Login/Register";
const publicRoutes = () => {
  return [
    {
      element: <PublicAuths />,
      children: [
        {
          path: "/admin",
          element: <Login />,
        },
        {
          path: "/register",
          element: <Register />,
        },
      ],
    },
  ];
};

export default publicRoutes;
